let overlay = null;
let isDragging = false;
let startX = 0;
let startY = 0;
let scrollLeft = 0;
let scrollTop = 0;

function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  const newOverlay = document.createElement('div');
  prepareOverlay(newOverlay, overlayImage);
  image.style.opacity = '50%';
  toggleLoadingSpinner(image);
  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(newOverlay, image);
    image.style.opacity = '100%';
    // Center the scroll after image loads
    centerScroll(newOverlay);
  };
  return newOverlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  
  // Create actual zoomed image instead of background
  const zoomedImg = document.createElement('img');
  zoomedImg.src = image.src;
  zoomedImg.style.width = '200%';
  zoomedImg.style.height = 'auto';
  zoomedImg.style.display = 'block';
  zoomedImg.style.cursor = 'grab';
  zoomedImg.style.userSelect = 'none';
  zoomedImg.style.webkitUserDrag = 'none';
  zoomedImg.draggable = false;
  
  container.appendChild(zoomedImg);
  
  // Make container scrollable
  container.style.overflow = 'auto';
  container.style.cursor = 'grab';
  container.style.backgroundColor = 'var(--gradient-background)';
  
  // Prevent default image drag
  zoomedImg.addEventListener('dragstart', (e) => {
    e.preventDefault();
    return false;
  });
  
  // Mouse drag to scroll
  container.addEventListener('mousedown', (e) => {
    isDragging = true;
    container.style.cursor = 'grabbing';
    zoomedImg.style.cursor = 'grabbing';
    startX = e.pageX - container.offsetLeft;
    startY = e.pageY - container.offsetTop;
    scrollLeft = container.scrollLeft;
    scrollTop = container.scrollTop;
  });
  
  container.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const y = e.pageY - container.offsetTop;
    const walkX = (x - startX) * 2; // Multiply for faster scroll
    const walkY = (y - startY) * 2;
    container.scrollLeft = scrollLeft - walkX;
    container.scrollTop = scrollTop - walkY;
  });
  
  container.addEventListener('mouseup', () => {
    isDragging = false;
    container.style.cursor = 'grab';
    zoomedImg.style.cursor = 'grab';
  });
  
  container.addEventListener('mouseleave', () => {
    isDragging = false;
    container.style.cursor = 'grab';
    zoomedImg.style.cursor = 'grab';
  });
  
  // Click to close (only if didn't drag)
  let clickStartTime = 0;
  let clickStartX = 0;
  let clickStartY = 0;
  
  zoomedImg.addEventListener('mousedown', (e) => {
    clickStartTime = Date.now();
    clickStartX = e.clientX;
    clickStartY = e.clientY;
  });
  
  zoomedImg.addEventListener('click', (e) => {
    const timeDiff = Date.now() - clickStartTime;
    const moveDiff = Math.abs(e.clientX - clickStartX) + Math.abs(e.clientY - clickStartY);
    
    // Only close if it was a quick click without much movement
    if (timeDiff < 300 && moveDiff < 10) {
      e.preventDefault();
      closeOverlay();
    }
  });
}

function centerScroll(container) {
  // Center the scroll position
  const scrollWidth = container.scrollWidth;
  const scrollHeight = container.scrollHeight;
  const clientWidth = container.clientWidth;
  const clientHeight = container.clientHeight;
  
  container.scrollLeft = (scrollWidth - clientWidth) / 2;
  container.scrollTop = (scrollHeight - clientHeight) / 2;
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) loadingSpinner.classList.toggle('hidden');
}

function toggleCloseButton(hide) {
  // Find the modal close button (X button)
  const modal = document.querySelector('.product-media-modal[open]');
  if (modal) {
    const closeBtn = modal.querySelector('.product-media-modal__toggle');
    const prevBtn = modal.querySelector('.product-zoom-button-prev');
    const nextBtn = modal.querySelector('.product-zoom-button-next');
    
    if (closeBtn) {
      closeBtn.style.display = hide ? 'none' : '';
    }
    if (prevBtn) {
      prevBtn.style.display = hide ? 'none' : '';
    }
    if (nextBtn) {
      nextBtn.style.display = hide ? 'none' : '';
    }
  }
}

function closeOverlay() {
  if (overlay) {
    overlay.remove();
    overlay = null;
    isDragging = false;
    // Show the exit button again
    toggleCloseButton(false);
  }
}

function magnify(image) {
  if (overlay) {
    closeOverlay();
    return;
  }
  
  overlay = createOverlay(image);
  // Hide the exit button when zoomed
  toggleCloseButton(true);
}

function enableZoomOnHover() {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      magnify(image);
    };
    
    image.addEventListener('dragstart', (e) => {
      e.preventDefault();
      return false;
    });
  });
}

enableZoomOnHover();